import axios from "axios";
import {
  handleAuthFailure,
  isAuthFailureResponse,
} from "@stocai/api";
import { deleteUserCookie, setLogoutSignal } from "../utils";

const API_BASE = process.env.REACT_APP_BACKEND_API_URL;

// Create dedicated axios instance
export const adminApi = axios.create({
  baseURL: `${API_BASE}/admin`,
});

// Auto attach token
adminApi.interceptors.request.use(
  (config) => {
    try {
      const raw = localStorage.getItem("user");
      if (raw) {
        const user = JSON.parse(raw);
        const token = user?.access_token;

        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
    } catch (err) {
      console.error("Failed to attach admin token:", err);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Optional: response error handling
adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const detail = error?.response?.data?.detail;
    if (isAuthFailureResponse(status, detail)) {
      setLogoutSignal();
      deleteUserCookie();
      handleAuthFailure();
    }
    return Promise.reject(error);
  }
);
